import { TAllModsBehavior } from '@westondev/tableturn-core';

export const ALL_MODS_OPTIONS: TAllModsBehavior[] = [
  TAllModsBehavior.ALL,
  TAllModsBehavior.ASSOCIATED,
  TAllModsBehavior.PREMADE,
];
